import * as Composer from '../actions/Composer';

export default () => {
    Composer.setShouldShowComposeInput(true);
};
